import {makeAutoObservable} from 'mobx';
import SubscriptionAgent from '../agent/subscription-agent';
import {CreateSubscriptionResponse} from '../../entity/resource/create-subscription-response';
import {RequestBody} from '../../entity/core/request-body';
import {SubscriptionsResponseObject} from '../../entity/resource/subscriptions-response';
import {CancelSubscriptionResponse} from '../../entity/resource/cancel-subscription-response';
import {TokenPackageResponse} from '../../entity/resource/token-package-response';
import {CreateCheckoutSessionResponse} from '../../entity/resource/create-checkout-session-response';
import {ConfirmPurchaseResponse} from '../../entity/resource/confirm-purchase-response';
import {TokenBalanceResponse} from '../../entity/resource/token-balance-response';
import {CostTypesResponse} from '../../entity/resource/cost-types-response';

export default class SubscriptionStore {
  subscriptionAgent: SubscriptionAgent;

  constructor(subscriptionAgent: SubscriptionAgent) {
    makeAutoObservable(this);
    this.subscriptionAgent = subscriptionAgent;
  }

  validateSubscriptions = async (organizationId: string): Promise<boolean> => {
    try {
      return await this.subscriptionAgent.validateSubscriptions(organizationId);
    } catch (error: any) {
      console.error('Error occurred while validate subscriptions', error);
    }

    return false;
  }

  getSubscriptions = async (organizationId: string): Promise<SubscriptionsResponseObject[]> => {
    try {
      const response = await this.subscriptionAgent.getSubscriptions(organizationId);
      if (!Array.isArray(response))
        return response.data;
    } catch (error: any) {
      console.error('Error occurred while get subscriptions', error);
    }

    return [];
  }

  subscribe = async (organizationId: string, isAnnual: boolean, requestBody: RequestBody): Promise<CreateSubscriptionResponse | string> => {
    try {
      return await this.subscriptionAgent.subscribe(organizationId, isAnnual, requestBody);
    } catch (error: any) {
      console.error('Error occurred while subscribe', error);
      return 'Error occurred while subscribe. Please try again in while !!';
    }
  }

  cancelSubscription = async (organizationId: string, subscriptionId: string): Promise<CancelSubscriptionResponse | string> => {
    try {
      return await this.subscriptionAgent.cancelSubscription(organizationId, subscriptionId);
    } catch (error: any) {
      console.error('Error occurred while cancel the subscription', error);
      return 'Error occurred while cancel the subscription. Please try again in while !!';
    }
  }

  updatePaymentMethod = async (organizationId: string): Promise<CreateSubscriptionResponse | string> => {
    try {
      return await this.subscriptionAgent.updatePaymentMethod(organizationId);
    } catch (error: any) {
      console.error('Error occurred while update payment method', error);
      return 'Error occurred while update payment method. Please try again in while !!';
    }
  }

  getTokenPackages = async (): Promise<TokenPackageResponse[] | string> => {
    try {
      return await this.subscriptionAgent.getTokenPackages();
    }
    catch(error: any) {
      console.error('Error occurred while getTokenPackages', error);
      return 'Error occurred while getTokenPackages !!';
    }
  }

  createCheckoutSession = async (organizationId: string, packageId:string): Promise<CreateCheckoutSessionResponse | string> => {
    try{
      return await this.subscriptionAgent.createCheckoutSession(organizationId, packageId);
    }
    catch(error: any) {
      console.error('Error occurred while createCheckoutSession', error);
      return 'Error occurred while createCheckoutSession !!';
    }
  }

  confirmPurchase = async (organizationId: string, requestBody: RequestBody): Promise<ConfirmPurchaseResponse | string> => {
    try{
      return await this.subscriptionAgent.confirmPurchase(organizationId, requestBody);
    }
    catch(error: any) {
      console.error('Error occurred while confirmPurchase', error);
      return 'Error occurred while confirmPurchase !!';
    }
  }

  getTokenBalance = async (organizationId: string): Promise<TokenBalanceResponse | string> => {
    try{
      return await this.subscriptionAgent.getTokenBalance(organizationId);
    }
    catch(error: any) {
      console.error('Error occurred while getTokenBalance', error);
      return 'Error occurred while getTokenBalance !!';
    }
  }

  getCostTypes = async (): Promise<CostTypesResponse[] | string> => {
    try{
      return await this.subscriptionAgent.getCostTypes();
    }
    catch(error: any) {
      console.error('Error occurred while getCostTypes !!');
      return 'Error occurred while getCostTypes !!';
    }
  }
}
